module.exports = __webpack_public_path__ + "img/guiji1.24c13391.png";